import React from "react";
import { InputGroup } from "react-bootstrap";
import { ColumnInstance } from "react-table";

import { FormattedMessage } from "react-intl";

type ColumnFilterItemProps = {
  column: ColumnInstance;
  eventContext: string; // eslint-disable-line react/no-unused-prop-types
  listViewName: string;
};

function ColumnFilterItem(props: ColumnFilterItemProps) {
  const { column, listViewName } = props;

  function saveColumnVisibilityToLocalStorage() {
    const hiddenColumns = localStorage.getItem(`${listViewName}_hidden_columns`);

    // If column was previously visible then we save as hidden in local storage
    if (column.isVisible) {
      if (hiddenColumns) {
        const hiddenColumnsArray = JSON.parse(hiddenColumns);
        if (!hiddenColumnsArray.includes(column.id)) {
          hiddenColumnsArray.push(column.id);
          localStorage.setItem(`${listViewName}_hidden_columns`, JSON.stringify(hiddenColumnsArray));
        }
      } else {
        localStorage.setItem(`${listViewName}_hidden_columns`, JSON.stringify([column.id]));
      }
    }

    // If column was previously hidden then we remove it from local storage
    if (!column.isVisible) {
      if (hiddenColumns) {
        const hiddenColumnsArray = JSON.parse(hiddenColumns);
        if (hiddenColumnsArray.includes(column.id)) {
          const updatedHiddenColumns = hiddenColumnsArray.filter((hiddenColumn: string) => hiddenColumn !== column.id);
          localStorage.setItem(`${listViewName}_hidden_columns`, JSON.stringify(updatedHiddenColumns));
        }
      }
    }
  }

  return (
    <div className="mb-10">
      <InputGroup className="checkbox bg-transparent mb-1">
        <label htmlFor={column.id} className="d-flex align-items-center cursor-pointer mb-0 w-100 column-min-width">
          <input
            id={column.id}
            type="checkbox"
            className="d-none"
            {...column.getToggleHiddenProps()}
            onClick={() => {
              saveColumnVisibilityToLocalStorage();
            }}
          />
          <span className="border-dark border-solid border-1 mr-2 position-relative br-3 checkbox__box" />
          <span className="font-b3 mr-auto column-max-width">
            {column.actions ? <FormattedMessage id="general.action" defaultMessage="Action" /> : column.render("Header")}
          </span>
        </label>
      </InputGroup>
    </div>
  );
}

export default ColumnFilterItem;
